import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDataField } from '../modules/data/actions';

/**
 * Ersetzt das frühere DataContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `data.xxx`/`data.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useDataState() {
    const data = useSelector((state) => state.data);
    const dispatch = useDispatch();

    const setObjects = useCallback((value) => dispatch(setDataField('objects', value)), [dispatch]);
    const setComponents = useCallback((value) => dispatch(setDataField('components', value)), [dispatch]);
    const setObjectsClicked = useCallback((value) => dispatch(setDataField('objectsClicked', value)), [dispatch]);
    const setComponentsClicked = useCallback((value) => dispatch(setDataField('componentsClicked', value)), [dispatch]);
    const setIsLoaded = useCallback((value) => dispatch(setDataField('isLoaded', value)), [dispatch]);
    const setDialogOpen = useCallback((value) => dispatch(setDataField('dialogOpen', value)), [dispatch]);

    return {
        objects: data.objects, setObjects,
        components: data.components, setComponents,
        objectsClicked: data.objectsClicked, setObjectsClicked,
        componentsClicked: data.componentsClicked, setComponentsClicked,
        isLoaded: data.isLoaded, setIsLoaded,
        dialogOpen: data.dialogOpen, setDialogOpen,
    };
}
